import React from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../GridLayout';

const Tabs = ({
  options,
  columns,
  selectedTab,
  setSelectedTab,
  isUnderlined,
  className
}) => {
  return (
    <GridLayout
      isTab={isUnderlined}
      columns={columns}
      selectedTabIndex={options.indexOf(selectedTab)}
      className={className}
    >
      {options.map(tab => {
        return (
          <div
            role="none"
            className={`tab ${tab === selectedTab && 'tab_selected'}`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </div>
        );
      })}
    </GridLayout>
  );
};

Tabs.propTypes = {
  options: PropTypes.array,
  columns: PropTypes.array,
  selectedTab: PropTypes.number,
  setSelectedTab: PropTypes.func,
  isUnderlined: PropTypes.bool,
  className: PropTypes.string
};

export default Tabs;
